import React from 'react';
import { Button, Image, Text } from '@fluentui/react-components';
import { ISectionErrorProps } from './SectionError.types';
import { useSectionErrorStyles } from './SectionError.styles';
/**
 * Error component with error image and optional try button
 */
export const SectionError = (props: ISectionErrorProps) => {
  let { title } = props;
  const styles = useSectionErrorStyles();
  const { className, onRefresh, description } = props;

  title = title || 'Something went wrong';

  return (
    <div className={styles.container}>
      <div className={`${styles.main}  ${className}`}>
        <div className={`${styles.main}  ${className}`}>
          <Image className={styles.image} src="/assets/error.svg" alt="" />
        </div>
        <Text weight="bold">{title}</Text>
        {description && <Text size={200}>{description}</Text>}
        {onRefresh && <Button onClick={onRefresh}>Refresh</Button>}
      </div>
    </div>
  );
};
